import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogContent,
} from '@material-ui/core';
import "../css/NewModal.css";
import { TiDelete } from "react-icons/ti";
import drop from "../assets/drop.png";
import DropDown from './DropDown';
import { getImageURL } from '../config/uploadmageFunction'
import { edituser, signup } from '../Path/Path';
import { toast } from 'react-toastify';
import { withRouter } from './withRouter';
import { connect } from 'react-redux';
import action from '../store/action';

const UserVisibleComponent = ({ open, onClick, type, active, getUserName, infoData, contact, DOB, triggeredTime, onUpdate, getEmail, getUserType, getLocation, getImage, userName, email, location, typeUser, image, lang, createdAt, getCreatedAt, storeName, getStoreName, id, getid, delegateTo, getdelegateTo }) => {

    const [show, setShow] = useState(false);
    console.log(email, "email.........")

    const imageHandler = (e) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                getImage(reader.result);
            }
        }
        setShow(true);
        getImage(e.target.files[0])
        reader.readAsDataURL(e.target.files[0])
    }


    const removeImage = () => {
        getImage("")
        setShow(false)
    }



    useEffect(() => {
    }, [])
    return (
        <Dialog aria-labelledby='dialog-title' aria-describedby='dialog-description' open={open}>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "15px" }}>


                <h2 className='h2-head'>{lang === "en" ? "View User" : "Afficher les utilisateur"}</h2>


                <div className='close-btn' onClick={onClick}><TiDelete /></div>
            </div>
            <div className='line'></div>
            <DialogContent>

                <div className="modal-main" >
                    <div className='input-flex'>
                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Name'>{lang === "en" ? "User Name" : "Nom d'utilisateur"}</label>
                            <input type="text" id='Name' disabled value={infoData?.userName} />
                        </div>


                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Date'>{lang === "en" ? "Email" : "E-mail"}</label>
                            <input type="email" disabled value={infoData?.email} id='email' />
                        </div>

                    </div>
                    <div className='input-flex'>

                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Date'>{lang === "en" ? "Contact" : "Contact"}</label>
                            <input type="email" disabled value={infoData?.phone} id='contact' />
                        </div>
                        {/* <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Tagline'>{lang === "en" ? "Type" : "Type"}</label>
                            <input type="text" id='Tagline' placeholder='select type' />
                            <DropDown
                                options={[
                                    { label: 'Select Option', value: 'Select Option' },
                                    { label: 'store', value: 'store' },
                                    { label: 'guard', value: 'guard' },

                                ]}
                                onChange={e => getUserType(e.target.value)}
                                value={typeUser}
                            />

                        </div> */}


                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Location'>{lang === "en" ? "Date of Birth" : "Emplacement"}</label>
                            <input type="text" disabled id='delegate to' value={infoData?.healthInfo?.DOB} />
                        </div>

                    </div>
                    <div className='input-flex'>
                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Name'>{lang === "en" ? "Sex" : "Sexe"}</label>
                            <input type="text" id='Name' disabled value={infoData?.healthInfo?.gender} />
                        </div>


                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Date'>{lang === "en" ? "Wheel Chair" : "Fauteuil Roulant"}</label>
                            <input type="email" disabled value={infoData?.healthInfo?.wheelchair} id='email' />
                        </div>

                    </div>
                    <div className='input-flex'>
                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Name'>{lang === "en" ? "Blood Group" : "Groupe sanguin"}</label>
                            <input type="text" id='Name' disabled value={infoData?.healthInfo?.bloodType} />
                        </div>

{/* 
                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Date'>{lang === "en" ? "Wheel Chair" : "Fauteuil Roulant"}</label>
                            <input type="email" disabled value={infoData?.healthInfo?.wheelChair} id='email' />
                        </div> */}

                    </div>

                    <div className='input-flex'>

                    </div>


                </div>

                {/* <div className="modal-main" >
                    <label htmlFor='Category'>{lang === "en" ? "Featured Images" : "Utvalgte bilder"}</label>
                    <div className='img-area-1'>
                        <div className='photo1'>
                            <img src={image ? image : drop} alt="" opa={show ? 0 : 1} className="opacit" />
                            <div className='show-img'>
                                <img src={image} alt="" opa={show ? 1 : 0} className='opacit' />
                                <div className='pic-del opacit' opa={show ? 1 : 0} onClick={removeImage} ><TiDelete /></div>
                            </div>
                            <p className='drag opacit' opa={show ? 0 : 1}>{lang === "en" ? "Drap Photos here" : "Dra bilder her"}</p>
                        </div>
                        <div className='img-src-btn1'>
                            <label htmlFor="files">{lang === "en" ? "Select From Computer" : "Velg Fra datamaskin"}</label>
                            <input type="file" id="files" accept='image/*' onChange={imageHandler} />
                        </div>
                    </div>
                </div> */}
            </DialogContent>
            <div className='but-flex'>
                <div className='cancel'>
                    {/* <button onClick={onClick}>{lang === "en" ? "Cancel" : "Avbryt"}</button> */}
                </div>
                <div className='save-changes'>


                    {/* <button onClick={() => onUpdate()}>{lang === "en" ? "Update" : "Oppdater"}</button> */}


                </div>
            </div>
        </Dialog>
    )
}

const mapStatetoProps = (state) => {
    return {
        user: state.user,
        lang: state.lang
    }
}
const mapDispatchtoProps = (dispatch) => {
    return {
        _setUsers: payload => dispatch(action.setUsers(payload)),
        _changeLang: payload => dispatch(action.changeLang(payload)),

    }
}



export default connect(mapStatetoProps, mapDispatchtoProps)(withRouter(UserVisibleComponent));
